import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pcpGenderIcon'
})
/**
 * Pipe for PCP icons depending on gender.
 */
export class PcpGenderIconPipe implements PipeTransform {

  transform(gender: string): string {
    const genderIcons:{ [key:string]: string; } = {
      'M': 'assets/icons/maleDoctor.svg',
      'F' : 'assets/icons/femaleDoctor.svg'
    };
    const icon = genderIcons[gender];
    return icon ? icon : 'assets/icons/genderUnknownDoctor.svg';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/pcp-gender-icon.pipe.ts